import { jobsActions } from "../../../../store/reducers/jobsReducer";
import moment from 'moment';
import _ from "lodash";
import { projectsActions } from '../../../../store/reducers/projectsReducer'
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var ProcessDetailsItems = (function () {
    function ProcessDetailsItems(object) {
        this.id = object.id;
        this.occurrence = object.occurrence;
        this.occurrenceTime = object.occurrenceTimeString;
        this.occurrenceDate = object.occurrenceDateString;
        this.jobQId = object.jobQId;
        this.message = object.message.replace('&nbsp', ' ');
        this.status = object.status;
        this.taskOrder = object.taskOrder;
        this.scriptExecutionLogRawLink = object.scriptExecutionLogRawLink;
        this.scriptExecutionLogDownloadLink = object.scriptExecutionLogDownloadLink;
        this.isOverSized = object.isOverSized;
        this.scriptExecutionLog = object.scriptExecutionLog;
        this.messageType = object.messageType;
        this.messageLinkTitle = object.messageLinkTitle;
    }
    return ProcessDetailsItems;
}());
exports.ProcessDetailsItems = ProcessDetailsItems;
var ProcessDetailsPopupController = (function () {
    function ProcessDetailsPopupController(store, $state, $stateParams, statuses, jobDetailsStatuses, processDetailsModalService, $filter, $timeout, consts, dialogManagerService) {
        this.store = store;
        this.loading = true;
        this.state = $state;
        this.stateParams = $stateParams;
        this.consts = consts;
        this.dialogManagerService = dialogManagerService;
        this.enableAyalysis = false;
        this.m_doAutoScrollActionLogToBottom = true;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.files = [];

        this.isRollbackExecution = false;

        this.lastTaskId = null;
        this.activityIcon = this.processData.activityIcon;
        var _this = this;
        this.downloadFile = (file) => {
            this.store.dispatch({ type: file.type, payload: file.payload });
        };
        this.showFiles = (executionData) => {
            this.files = [];
            let buttonTitle = null;
            if (executionData.ReportLinks == null) {
                return;
            }

            switch (executionData.Title) {
                case "ENV_VALIDATE":
                    //title = "Validation Report";
                    break;
                case "ENV_BUILD":
                    //title = "Build Report";
                    break;
                case "ENV_CUSTOM_BUILD":
                    //title = "Custom Build Report";
                    break;
                case "ENV_BUILD_BY_TASKIDS":
                    //title = "build by taskId";
                    break;
                case "ENV_DRIFT_DETECTION":
                    buttonTitle = 'Drift Report';
                    break;
                case "PRECHECK":
                    buttonTitle = this.$filter('changeEnumJobNameToName')('PRECHECK');
                default:
                    break;
            }

            this.schemasReports = [];
            this.Reports = [];
            executionData.ReportLinks.forEach((item) => {
                const report = this.reportLink(item);
                if (report) {
                    /*report.title = ReportLinks.title;
                    if (buttonTitle) {
                        report.title =  ReportLinks.title;
                    } else {
                        report.title += report.title === 'Pre' || report.title === 'Post' ? 'Check' : ' Impact Analysis';
                    }*/
                    this.Reports.push(report)
                }
            });
            
        };
        this.reportLink = function (entity) {
            //if (entity.ReportType != "html" && entity.ReportType != "ImpactAnalysisJson") {
            const report = {
                    //EnvironmentId: entity.EnvId || null,
                    EnvironmentId: this.stateParams.envID || null,
                    Title: entity.Title,
                    ReportOperationType: entity.ReportOperationType,
                    JobId: entity.JobId,
                    ProjectId: this.stateParams.id,
                    reportId: entity.ReportId
                }
                return report;
          //  }
        }

        this.convertUTCtoLocal = function (date, flag) {
            if (!date)
                return;

            const stillUtc = moment.utc(date).toDate();
            const local = moment(stillUtc).local().toDate();
            if (!flag)
                return local.toLocaleString();
            else if (flag == "date")
                return local.toLocaleString([], { day: 'numeric', month: 'numeric', year: 'numeric' });
            else if (flag == "time")
                return local.toLocaleString([], { hour: 'numeric', minute: 'numeric', second: 'numeric' });
        }

        this.m_getJobExecution = function (postback) {
            _this.store.dispatch({
                type: jobsActions.GET_JOB_EXECUTION,
                payload: { jobQId: _this.processData.JobQId },
                silentRequest: true,
                customErrorHandling: true,
            })
                .then(function (resp) {
                _this.processData = resp.data;
                if (_this.processData.Status > 1) {
                    _this.m_clearDataPulling();
                    _this.showFiles(_this.processData);
                    _this.activityIcon = _this.getCorrespondingStatusIcon(_this.processData.Status)
                }
                //check for upgrade with "__Rollback" and change it to Rollback Execution 
                let isRollbackExe1 = "";
                if(_this.processData.VersionNames)
                    isRollbackExe1= _this.processData.VersionNames.split("__")
                let isRollbackExe2 = "";
                if(isRollbackExe1.length > 1)
                    isRollbackExe2= isRollbackExe1[1].split("_");
                let stageName = "";
                if(isRollbackExe2.length > 0 && isRollbackExe2[0] === "Rollback")
                {
                    _this.processData.Title = "Rollback Execution";
                    _this.isRollbackExecution = true;
                }
                else
                    _this.processData.Title = _this.$filter('changeEnumJobNameToName')(_this.processData.Title) + (_this.processData.VersionNames ? ' - ' + _this.processData.VersionNames : '');
                _this.processData.CreatedOn = _this.convertUTCtoLocal(_this.processData.CreatedOn, null);
                if (postback != null) {
                    postback();
                }
            }, function () { });
        };

        this.getJobCompletionPercentage = function () {
            const jobCompletions = _this.store.getState().jobs.jobCompletionPercentage;
            if (jobCompletions) {
                const jobCompletionState = jobCompletions.find(job => job.jobId == _this.processData.JobQId);
                return (jobCompletionState && jobCompletionState.completionPercentage) || "1";
            }
            return "1";
        }
        //icon in activities - color and shape
        this.getCorrespondingStatusIcon = (type) => {
            return (!this.activityIcon) ? this.statuses[type].Icon : this.activityIcon;
        };

        this.noPropagation = function ($event) {
            $event.stopPropagation();
        };

        this.navigateImpactAnalysis = function ($event, report) {
            $event.stopPropagation();
            const jobParams = this.processData.JobParams;
            const projectId = report.ProjectId;
            const url = $state.href('app.authorized.project-impact-analysis', {
                projectId,
                jobId: report.JobId,
                //jobType: report.Title,
                //jobEnv: report.EnvironmentId,
                reportId: report.reportId,
                isRollbackExecution: this.isRollbackExecution

            });
            // this.state.go('app.authorized.project-impact-analysis', {
            //     projectId,
            //     jobId: report.JobId,
            //     //jobType: report.Title,
            //     //jobEnv: report.EnvironmentId,
            //     reportId: report.reportId,
            //     isRollbackExecution: this.isRollbackExecution
            // })
            //this.close();
            window.open(url, '_blank');
            /* {"JobQId":4,"Title":"ENV_BUILD","Status":5,"JobStatusMessage":null,"CreatedBy":"admin@dbmaestro.com","CreatedOn":"2017-08-07T16:08:29.943","JobParams":[{"TaskIndex":1,"Key":"TARGET_ENVIRONMENT_ID","Value":null},{"TaskIndex":1,"Key":"TARGET_PROJECT","Value":"2"},{"TaskIndex":1,"Key":"SOURCE_ENV_ID","Value":"3"},{"TaskIndex":1,"Key":"TARGET_LABEL_ID","Value":null},{"TaskIndex":1,"Key":"SOURCE_LABEL_ID","Value":null},{"TaskIndex":1,"Key":"TARGET_BASELINE_ID","Value":null},{"TaskIndex":1,"Key":"PROP_SOURCE_DEPLOY_COMPARISON_TYPE","Value":"1"},{"TaskIndex":1,"Key":"PROP_TARGET_DEPLOY_COMPARISON_TYPE","Value":"1"}],"ExecutionDuration":"00:00:13","StartedOn":"2017-08-07T16:08:31.631","EndedOn":"2017-08-07T16:08:45.302","PercentageComplete":100,"ProcessingData":null,"ReportLinks":[{"EnvironmentName":null,"SchemaName":"hr2","LabelName":null,"Title":null,"Link":"http://192.168.16.132:88#/files/build/validation-report/4/schema/1","RelativeLink":"#/files/build/validation-report/4/schema/1","ReportType":"html"}],"ProjectName":"test","EnvironmentNames":"dev_env_1"}*/
            //_this.store.dispatch({
            //    type: file.type,
            //    payload: { projectId: }
            //})
        };
        this.$onDestroy = function () {
            clearInterval(_this.pullingInterval);
            _this.destroyed = true;
        };
        this.statuses = statuses;
        this.jobDetailsStatuses = jobDetailsStatuses;
        this.m_processDetailsModalService = processDetailsModalService;
        if (this.doFetchByJobQId) {
            this.m_getJobExecution(function () {
                _this.m_setDataPulling(3000);
                _this.m_loadJobItems(true);
            });
        } else {
            this.m_loadJobItems(true);
            this.m_setDataPulling(3000);
        }
    }
    ProcessDetailsPopupController.prototype.close = function () {
        this.m_clearDataPulling();
        this.m_processDetailsModalService.CloseProcessDetailsModal();
    };
    ProcessDetailsPopupController.prototype.m_loadJobItems = function (isFirstCall) {
        const _this = this;
        if (isFirstCall) {
            _this.detailsItems = [];
            _this.store.dispatch({
                type: jobsActions.GET_JOB_DATA,
                payload: { jobQId: _this.processData.JobQId },
                silentRequest: true,
                customErrorHandling: true,
            })
            .then(function (response) {
                _this.lastTaskId = 0;
                response.data.forEach(function (val, index, items) {
                    const occurrenceDateObjectDate = _this.convertUTCtoLocal(val.occurrence, "date");
                    const occurrenceDateObjectTime = _this.convertUTCtoLocal(val.occurrence, "time");
                    val.occurrenceDateString = occurrenceDateObjectDate;
                    val.occurrenceTimeString = occurrenceDateObjectTime;
                    _this.detailsItems.push(new ProcessDetailsItems(val));
                    if (_this.lastTaskId < val.id) {
                        _this.lastTaskId = val.id
                    }
                });
                _this.m_setLoading(false);
            }, function () {
                _this.m_setLoading(false);
            });
        } else {
            if (this.lastTaskId) {
                _this.store.dispatch({
                    type: jobsActions.GET_JOB_DATA_BY_TASK_ID,
                    payload: { jobQId: _this.processData.JobQId, fromId: this.lastTaskId },
                    silentRequest: true,
                    customErrorHandling: true,
                }).then(function (response) {
                    const itemsArr = _this.detailsItems;
                    response.data.forEach(function (val, index, items) {
                        const occurrenceDateObjectDate = _this.convertUTCtoLocal(val.occurrence, "date");
                        const occurrenceDateObjectTime = _this.convertUTCtoLocal(val.occurrence, "time");
                        val.occurrenceDateString = occurrenceDateObjectDate;
                        val.occurrenceTimeString = occurrenceDateObjectTime;
                        itemsArr.push(new ProcessDetailsItems(val));
                        if (_this.lastTaskId < val.id) {
                            _this.lastTaskId = val.id
                        }
                    });
                    _this.detailsItems = _this.$filter('orderBy')(itemsArr, ['id'], true);
                    _this.m_setLoading(false);
                }, function () {
                    _this.m_setLoading(false);
                });
            }
        }
    };
    ProcessDetailsPopupController.prototype.m_setLoading = function (isLoading) {
        this.loading = isLoading;
    };

    ProcessDetailsPopupController.prototype.showAudit = function (item) {
        //if its console output link then take the 3 parameters from it and dispatch get_rawdata
        if (item.message.substr(0,4)==="http" && item.message.substr(-7) === "RawData")
        {
            const breakWords = item.message.split('/');
            this.store.dispatch({
                type: projectsActions.GET_RAWDATA,
                payload: {
                    projectId: breakWords[5],
                    jobQid: breakWords[6],
                    executionId: breakWords[7]
                }
            })
            .then( (response) => {
                this.dialogManagerService.showScriptViewerDialog({
                    dispatch: (action) => this.store.dispatch(action),
                    rawLink: item.scriptExecutionLogRawLink,
                    downloadLink: item.scriptExecutionLogDownloadLink,
                    script: response,
                    isOverSize: item.isOverSized,
                    viewerType: this.consts.viewerType.Audit
                });
            })
        }
        else
        {
            this.dialogManagerService.showScriptViewerDialog({
                dispatch: (action) => this.store.dispatch(action),
                rawLink: item.scriptExecutionLogRawLink,
                downloadLink: item.scriptExecutionLogDownloadLink,
                script: item.scriptExecutionLog,
                isOverSize: item.isOverSized,
                viewerType: this.consts.viewerType.Audit
            });
        }
    };
    ProcessDetailsPopupController.prototype.onOpenWindow = function (url) {
        window.open(url, '_blank');
    };
    ProcessDetailsPopupController.prototype.m_setDataPulling = function (timeout) {
        var _this = this;
        if (_this.pullingInterval == null) {
            _this.pullingInterval = setInterval(function () {
                if (_this.destroyed) {
                    clearInterval(_this.pullingInterval);
                    _this.pullingInterval = null;
                    return;
                }
                _this.m_getJobExecution();
                _this.m_loadJobItems(false);
            }, timeout);
        }
    };
    ProcessDetailsPopupController.prototype.m_clearDataPulling = function () {
        clearInterval(this.pullingInterval);
        this.pullingInterval = null;
    };
    return ProcessDetailsPopupController;
}());
ProcessDetailsPopupController.$inject = ['store', '$state', '$stateParams', 'statuses', 'jobDetailsStatuses', 'processDetailsModalService', '$filter', '$timeout', 'consts', 'dialogManagerService'];
var ProcessDetailsPopupComponent = (function () {
    function ProcessDetailsPopupComponent() {
        this.bindings = {
            processData: '<',
            doFetchByJobQId: '<'
        };
        this.controller = ProcessDetailsPopupController;
        this.template = require('./processDetailsPopup.tpl.html');
        this.styles = require("./_processDetailsPopup.scss");
    }
    return ProcessDetailsPopupComponent;
}());
exports.ProcessDetailsPopupComponent = ProcessDetailsPopupComponent;
var ScrollToBottom = (function () {
    function ScrollToBottom() {
        this.scope = {
            watchItems: "<",
            doScrollToBottom: "<"
        };
        ScrollToBottom.prototype.link = function (scope, element) {
            scope.$watchCollection("watchItems", function () {
                if (scope.doScrollToBottom == null || scope.doScrollToBottom) {
                    element[0].scrollTop = element[0].scrollHeight;
                }
            });
            element[0].addEventListener("scroll", function (e) {
                //TODO: cancel scroll on user initiated scroll and return auto scroll on scroll to bottom
                // scope.doScrollToBottom = false;
            });
        };
    }
    ScrollToBottom.Factory = function () {
        var directive = function () {
            return new ScrollToBottom();
        };
        directive['$inject'] = [];
        return directive;
    };
    return ScrollToBottom;
}());
exports.ScrollToBottom = ScrollToBottom;
//# sourceMappingURL=processDetailsPopup.js.map



// WEBPACK FOOTER //
// ./src/app/common/components/processDetailsPopup/processDetailsPopup.js